module.exports = __webpack_public_path__ + "img/深湾科技logo2021-横版@2x.3c382fa6.png";